import { Checkbox } from "@nike/eds";
import { useI18nContext } from "../../../../context/language/use-i18n-context";
import { FC } from "react";
import { ts } from "../i18n";

export interface Props {
    handleGovtCompliance: () => void;
    policyLocationId: number;
}
export const GovtCompliance: FC<Props> = ({ handleGovtCompliance, policyLocationId }) => {
        const { i18nString } = useI18nContext();
    return (
        <>
            <div className="modal__panel">
                <div>
                    <Checkbox
                        className={'eds-spacing--mr-12 eds-spacing--mt-5'}
                        id="govtCompliance"
                        name="govtCompliance"
                        hideLabel={true}
                        label="Government Complinace"
                        aria-label="Government Complinace Checkbox"
                        onClick={() => handleGovtCompliance()}
                    />
                </div>
                    {policyLocationId === 344 &&
                        <p>{i18nString(ts.GOVT_COMPLIANCE_HONGKONG)}</p>
                    }
                    {policyLocationId === 158 &&
                        <p>{i18nString(ts.GOVT_COMPLIANCE_TAIWAN)}</p>
                    }
                    {policyLocationId === 156 &&
                        <p>{i18nString(ts.GOVT_COMPLIANCE_CHINA)}</p>
                    }
                <div className="cb"></div>
            </div>
        </>
    )

}